import React, { useEffect, useState } from "react";
import PanelHead from "../../Panel/PanelHead";
import PanelBody from "../../Panel/PanelBody";
import { Helper } from "../../../tools/Helper";
import { api_Routes } from "../../../tools/api_Routes";
import { useParams } from "react-router-dom";
import { CircularProgress, LinearProgress } from "@mui/material";
import { FormEditSubCategory } from "./FormEditSubCategory";

export const PanelEditSubCategory = () => {
  const [isCategoriesLoading, setCategoriesLoading] = useState(true);
  const [categories, setCategories] = useState([]);
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({
    name: "",
    category_id: "",
  });
  const getData = async () => {
    try {
      const { result, response } = await Helper.Get({
        url: `${api_Routes.SubCategories.View}/${id}`,
      });

      if (response) {
        setData({
          name: response.data.name || "",
          category_id: response.data.category_id || "",
        });
      }
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };
  const getCategories = async () => {
    setCategoriesLoading(true);
    const { response, message } = await Helper.Get({
      url: `${api_Routes.Categories.ViewAll}`,
      hasToken: true,
    });
    if (response) {
      setCategories(response?.data);
    }
    setCategoriesLoading(false);
  };

  useEffect(() => {
    getData();
    getCategories();
  }, []);

  return (
    <div>
      {" "}
      <PanelHead
        title={
          isLoading ? (
            <div className="flex items-center gap-4">
              Edit SubCategory <CircularProgress size={24} />
            </div>
          ) : (
            <div className="flex items-center justify-between w-full gap-4">
              <div>Edit SubCategory: {data?.name}</div>
            </div>
          )
        }
      />
      <PanelBody
        content={
          isLoading ? (
            <LinearProgress />
          ) : (
            <FormEditSubCategory
              data={data}
              setData={setData}
              categories={categories}
              isCategoriesLoading={isCategoriesLoading}
            />
          )
        }
      />
    </div>
  );
};
